// 全局 Toast 工具
let toastInstance = null

const Toast = {
  // 显示 Toast
  show(message, duration = 2000) {
    // 如果已有 Toast 实例，先清除
    this.hide()

    // 创建 Toast 元素
    const toastEl = document.createElement('div')
    toastEl.className = 'global-toast'
    toastEl.textContent = message

    // 添加样式
    const styles = {
      position: 'fixed',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.75)',
      color: '#fff',
      padding: '0.22rem 0.35rem',
      borderRadius: '0.1rem',
      fontSize: '0.32rem',
      zIndex: '9999',
      whiteSpace: 'nowrap',
      pointerEvents: 'none'
    }

    // 应用样式
    Object.assign(toastEl.style, styles)

    // 添加到页面
    document.body.appendChild(toastEl)
    toastInstance = toastEl

    // 设置自动隐藏
    setTimeout(() => {
      this.hide()
    }, duration)
  },

  // 隐藏 Toast
  hide() {
    if (toastInstance && toastInstance.parentNode) {
      toastInstance.parentNode.removeChild(toastInstance)
      toastInstance = null
    }
  }
}

export default Toast
